/**
 * Module dependencies.
 */

import { JSX } from 'react';
import { Link } from '../link/link';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  email: string;
  style?: JSX.IntrinsicElements['a']['style'];
};

/**
 * Export `EmailLink` component.
 */

export function EmailLink({ className, email, style }: Props): JSX.Element {
  return (
    <Link className={className} href={`mailto:${email}`} passHref style={style}>
      {email}
    </Link>
  );
}
